import * as Utils from 'Assets/Utils'

import { List, Map } from 'immutable'

import ClientHttpRequest from "Api/ClientHttpRequest"
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Map({}).set('contacts', new Map({}).set('contactos', new Map({}).set('contacto', new List([]))))

/* Types */
export const GET_CONTACTS = 'GET_CONTACTS'
export const NEW_CONTACTS = 'NEW_CONTACTS'
export const DELETE_CONTACTS = 'DELETE_CONTACTS'


/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_CONTACTS:
			return state.set('contacts', new Map(action.Obj))
		case NEW_CONTACTS:
			return state.set('newContact', true)
		case DELETE_CONTACTS:
			return state.set('deleteContact', true)
		default:
			return state
	}
}

/* Action Creators */
export const getContacts = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getInformationContacts',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {

			let data = response.data
			let obj = {}

			if (data.contactos === null) {
				obj = { contacto: [] }
			} else {
				obj = { contacto: data.contactos.contacto }
			}
			dispatch(isLoading(false))
			dispatch({ type: GET_CONTACTS, Obj: obj })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const newContacts = (form) => {
	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newInformationContacts',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: NEW_CONTACTS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteContacts = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/deleteInformationContacts',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: DELETE_CONTACTS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const saveFlagNotification = (form) => {

	let contactos = form.contactsList.map((c) => {
		return {
			deleted: false,
			enviarCorreo: c.enviarCorreo,
			idContacto: c.idContacto,
			idDonataria: form.idDonataria
		}
	})

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/saveFlagNotification',
			method: "POST",
			data: { contactos },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


// WEBPACK FOOTER //
// ./src/modules/Grantees/Information/Contacts.js